/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function FormLabel({
  title,
  description,
  disabled,
  required,
  htmlFor,
  ...props
}) {
  return (
    <div
      className={classNames(
        Styles.mainContainer,
        {
          [Styles.disabled]: disabled,
        },
      )}
      {...props}
    >
      {title && (
        <label
          className={classNames(
            Styles.title,
            { [Styles.required]: required },
          )}
          htmlFor={htmlFor}
        >
          {title}
        </label>
      )}
      {description && (
        <label
          className={classNames(
            Styles.description,
          )}
          htmlFor={htmlFor}
        >
          {description}
        </label>
      )}
    </div>
  );
}

FormLabel.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  htmlFor: PropTypes.string,
};

FormLabel.defaultProps = {
  title: '',
  description: '',
  disabled: false,
  required: false,
  htmlFor: '',
};
